import React, { useState } from "react";
import classes from "../../components/Post.module.css";
import Button from "../../components/Button";
import FAQData from "./FAQData";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function FAQList({ post = "" }) {
  const [activeId, setActiveId] = useState(null);

  const filteredFAQ = FAQData.filter((faq) =>
    faq.question.toLowerCase().includes(post.toLowerCase()),
  );

  const handleToggle = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQData.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: [
                  ...(faq.description || []),
                  faq.p1,
                  faq.p2,
                  faq.p3,
                  faq.p4,
                  faq.p5,
                ]
                  .filter(Boolean)
                  .join(" "),
              },
            })),
          })}
        </script>
      </Helmet>

      <div className="container">
        <div className="row">
          {filteredFAQ.map((faq) => (
            <div key={faq.id} className="col-12 mb-4">
              <div className="card border-0 shadow-sm overflow-hidden">
                <div className="row g-0 align-items-stretch">
                  {/* Fixed Image */}
                  {faq.ImgSrc && (
                    <div className="col-lg-6">
                      <img
                        src={faq.ImgSrc}
                        className="img-fluid w-100"
                        alt={faq.question}
                      />
                    </div>
                  )}

                  {/* Content */}
                  <div className="col-sm-6 d-flex flex-column p-4">
                    <div className={`${classes.post} flex-grow-1`}>
                      {/* Question + Preview */}

                      <h5 className="fw-bold m-lg-0">{faq.question}</h5>

                      {faq.description?.map((item, index) => (
                        <p key={index} className="">
                          {item}
                        </p>
                      ))}

                      {/* Preview */}
                      {!activeId || activeId !== faq.id ? (
                        <>
                          {faq.id === "3" ? (
                            <>
                              {faq.p1 && <p>{faq.p1}</p>}
                              {faq.ul1Heading && <p>{faq.ul1Heading}</p>}
                              {faq.ul?.length > 0 && (
                                <ul>
                                  {faq.ul.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              )}
                            </>
                          ) : (
                            <>
                              {faq.p1 && <p>{faq.p1}</p>}
                              {faq.ul1Heading && (
                                <h5 className="mt-3 mb-2">{faq.ul1Heading}</h5>
                              )}
                              {faq.ul?.length > 0 && (
                                <ul>
                                  {faq.id != "2" && faq.ul[0].length <= 150 && (
                                    <li>{faq.ul[1]}</li>
                                  )}

                                  {faq.ul[1] && faq.ul[1].length <= 100 && (
                                    <li>{faq.ul[1]}</li>
                                  )}
                                </ul>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {faq.p1 && <p>{faq.p1}</p>}

                          {faq.ul1Heading && (
                            <h5 className="mt-3 mb-2">{faq.ul1Heading}</h5>
                          )}

                          {faq.ul?.length > 0 && (
                            <ul>
                              {faq.ul.map((item, index) => (
                                <li key={index} className="mb-2">
                                  {item}
                                </li>
                              ))}
                            </ul>
                          )}

                          {faq.p2 && <p>{faq.p2}</p>}
                          {faq.p3 && <p>{faq.p3}</p>}
                          {faq.p4 && <p>{faq.p4}</p>}
                          {faq.ul2Heading && (
                            <h5 className="mt-3 mb-2">{faq.ul2Heading}</h5>
                          )}
                          {faq.ul2?.length > 0 && (
                            <ul>
                              {faq.ul2.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          )}

                          {faq.p5 && <p>{faq.p5}</p>}

                          {faq.summary?.length > 0 && (
                            <div className="bg-light rounded p-3 mt-3">
                              <h4 className="fw-bold mb-3">{faq.summary[0]}</h4>

                              <ul className="mb-0">
                                {faq.summary.slice(1).map((item, index) => (
                                  <li key={index} className="mb-2">
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    {/* Button */}
                    <div className="mt-auto pt-3">
                      {faq.link ? (
                        <Link
                          to={faq.link}
                          className=" btn btn-primary w-100 rounded-pill link-opacity-25-hover text-decoration-none px-4 align-self-start"
                        >
                          Read More →
                        </Link>
                      ) : (
                        <button
                          className=" btn btn-primary w-100 rounded-pill link-opacity-25-hover text-decoration-none px-4 align-self-start"
                          onClick={() => handleToggle(faq.id)}
                        >
                          {activeId === faq.id ? "Read Less ▲" : "Read More ▼"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {filteredFAQ.length === 0 && (
            <div className="text-center py-5">
              <h5>No FAQs Found</h5>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
